import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportTransactionsPdf = ({
  rows,
  currency,
  fmt,
  title = 'Transaction Ledger',
  filePrefix = 'transaction-ledger',
  filterSummary = '',
}) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const pageW = doc.internal.pageSize.getWidth();

  doc.setFillColor(196, 69, 105);
  doc.rect(0, 0, pageW, 22, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(title, 14, 14);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text(
    `Currency: ${currency.flag} ${currency.name} (${currency.code})  |  Generated: ${new Date().toLocaleString()}  |  Records: ${safeRows.length}`,
    pageW - 14,
    14,
    { align: 'right' }
  );

  let startY = 28;
  if (filterSummary) {
    doc.setFontSize(7.5);
    doc.setTextColor(120, 80, 100);
    doc.setFont('helvetica', 'italic');
    doc.text(`Filters: ${filterSummary}`, 14, startY);
    startY += 6;
  }

  let totalIncome = 0;
  let totalExpense = 0;
  safeRows.forEach((r) => {
    const amount = parseFloat(r.amount) || 0;
    if (r.type === 'receipt') totalIncome += amount;
    else totalExpense += amount;
  });
  const netBalance = totalIncome - totalExpense;

  const boxes = [
    { label: 'Total Income', value: totalIncome, color: [245, 205, 121], textColor: [122, 82, 0] },
    { label: 'Total Expense', value: totalExpense, color: [252, 224, 232], textColor: [196, 69, 105] },
    { label: 'Net Balance', value: netBalance, color: [207, 106, 135], textColor: [255, 255, 255] },
  ];

  const boxW = 60;
  const boxH = 14;
  const boxGap = 6;
  let bx = 14;
  boxes.forEach((b) => {
    doc.setFillColor(...b.color);
    doc.roundedRect(bx, startY, boxW, boxH, 2, 2, 'F');
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...b.textColor);
    doc.text(b.label, bx + 4, startY + 5);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text(fmt(b.value), bx + 4, startY + 11);
    bx += boxW + boxGap;
  });
  startY += boxH + 6;

  autoTable(doc, {
    startY,
    head: [['#', 'Date', 'Project', 'Description', 'Type', 'Amount', 'Running Balance']],
    body: safeRows.map((r, i) => [
      i + 1,
      r.date,
      r.project_name || '—',
      r.description,
      r.type === 'receipt' ? '↑ Receipt' : '↓ Payment',
      `${r.type === 'receipt' ? '+' : '−'}${fmt(r.amount)}`,
      fmt(r.running_balance),
    ]),
    styles: { fontSize: 8, cellPadding: 3 },
    headStyles: { fillColor: [196, 69, 105], textColor: 255, fontStyle: 'bold', fontSize: 8 },
    alternateRowStyles: { fillColor: [253, 240, 244] },
    columnStyles: {
      0: { cellWidth: 10 },
      3: { cellWidth: 60 },
      5: { halign: 'right' },
      6: { halign: 'right' },
    },
    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 5) {
        const isReceipt = data.row.raw[4] === '↑ Receipt';
        data.cell.styles.textColor = isReceipt ? [120, 80, 0] : [196, 69, 105];
        data.cell.styles.fontStyle = 'bold';
      }
    },
    foot: [['', '', '', '', 'Net Balance', '', fmt(netBalance)]],
    footStyles: { fillColor: [196, 69, 105], textColor: 255, fontStyle: 'bold', fontSize: 8 },
    showFoot: 'lastPage',
    margin: { left: 14, right: 14 },
  });

  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i += 1) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(180, 100, 130);
    doc.text(
      `Page ${i} of ${pageCount}  |  ${title}`,
      pageW / 2,
      doc.internal.pageSize.getHeight() - 6,
      { align: 'center' }
    );
  }

  const fileName = `${filePrefix}-${currency.code}-${new Date().toISOString().slice(0, 10)}.pdf`;
  doc.save(fileName);
};
